import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({}: any) {
    const { locale } = useRouter();
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const list = [
        {
            src: ['kitKSwiper_winter.webp', 'kitKSwiper_winter.jpg'],
        },
        {
            src: ['kitKSwiper_spring.webp', 'kitKSwiper_spring.jpg'],
        },
        {
            src: ['kitKSwiper_summer.webp', 'kitKSwiper_summer.jpg'],
        },
        {
            src: ['kitKSwiper_autume.webp', 'kitKSwiper_autume.jpg'],
        },
    ];

    return (
        <div className={`${css.kitK} kitK`}>
            <div className="kit-ms-box">
                <div className="kit-ms-box-in">
                    <div className="kit-ms1">{t('presale.product.kitK_ms1')}</div>
                    <div className="kit-ms2">{t('presale.product.kitK_ms2')}</div>
                </div>
            </div>
            <div className="kit-img1">
                <EFPic name={['kitK1.webp', 'kitK1.jpg']} className="fullImgs" alt={t('presale.product.kitK_ms1')} />
            </div>
            {!['au'].includes(locale) && (
                <>
                    <div className="kit-img2">
                        <Swiper
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Autoplay]}
                            preloadImages={false}
                            lazy={true}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                            loop
                            effect="fade"
                            className="kit-swiper"
                        >
                            {list?.map((item: any, index: any) => (
                                <SwiperSlide key={index}>
                                    <EFPic name={item.src} className="fullImgs swiper-img" alt={t('presale.product.kitK_ms1')} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className="kit-ms3">{t('presale.product.kitK_ms3')}</div>
                    <div className="kit-ms4">{t('presale.product.kitK_ms4')}</div>
                </>
            )}
        </div>
    );
}
